import { render, staticRenderFns } from "./OrderSession.vue?vue&type=template&id=206b0746&scoped=true&"
import script from "./OrderSession.vue?vue&type=script&lang=js&"
export * from "./OrderSession.vue?vue&type=script&lang=js&"
import style0 from "./OrderSession.vue?vue&type=style&index=0&id=206b0746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b0746",
  null
  
)

export default component.exports